"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScopeService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("typeorm");
const employee_hierarchy_entity_1 = require("../../../../../apps/services/service-lib/src/lib/entities/employee_hierarchy.entity");
const user_1 = require("../../../../../apps/services/service-lib/src/lib/entities/user");
const employee_entity_1 = require("../../../../../apps/services/service-lib/src/lib/entities/employee.entity");
const entities_1 = require("../../../../../apps/services/service-lib/src/lib/entities");
const entity_service_utils_1 = require("./entity-service.utils");
const constants_1 = require("../constants");
let ScopeService = class ScopeService {
    constructor(dataSource, entityService) {
        this.entityService = entityService;
        this.dataSource = dataSource;
    }
    /**
     * Retrieves data to define scope.
     */
    async validateScope(fetchEntityData, userId, entity) {
        const employeeDetails = await this.dataSource
            .getRepository(employee_entity_1.Employee)
            .findOne({
            where: { userId: userId },
        });
        if (!employeeDetails) {
            return {
                status: common_1.HttpStatus.UNAUTHORIZED,
                message: "User not found",
            };
        }
        const user = await this.dataSource.getRepository(user_1.User).findOne({
            where: [{ userId: userId }],
            relations: ["userRoles", "userRoles.role"],
        });
        const roles = (user?.userRoles || [])
            .filter((userRole) => userRole?.role) // Filter out undefined roles
            .map((userRole) => ({
            id: userRole.role.id,
            name: userRole.role.name,
        }));
        if (!fetchEntityData) {
            return {
                status: common_1.HttpStatus.BAD_REQUEST,
                message: "Invalid fetch entity data",
            };
        }
        const additionalUserIds = [];
        const taggedResourceIds = [];
        for (const role of roles) {
            if (role.name.includes("LeaderShip")) {
                fetchEntityData.where = undefined;
                break;
            }
            if (entity !== "opportunity") {
                const orgUsersId = await this.fetchOrgUserIds(employeeDetails.organisationId);
                additionalUserIds.push(...orgUsersId);
            }
            else {
                if (["AM", "ISG"].includes(role.name)) {
                    const branchUsersId = await this.fetchBranchUserIds(employeeDetails.branchId);
                    additionalUserIds.push(...branchUsersId);
                }
                else {
                    const reporteeUserIds = await this.fetchReporteeUserIds(userId);
                    additionalUserIds.push(...reporteeUserIds);
                }
                const resourceIds = await this.fetchTaggedOprty([
                    ...additionalUserIds,
                    userId,
                ]);
                taggedResourceIds.push(...resourceIds);
            }
        }
        fetchEntityData.userFilter = { userId: userId, reporteeUserIds: [] };
        fetchEntityData.userFilter?.reporteeUserIds?.push(...additionalUserIds);
        if (taggedResourceIds.length > 0) {
            fetchEntityData.userFilter.tagged = [];
            fetchEntityData.userFilter?.tagged?.push(...taggedResourceIds);
        }
        return await this.entityService.fetchEntityList(fetchEntityData.entity, fetchEntityData.page, fetchEntityData.limit, fetchEntityData.sort, fetchEntityData.relations, fetchEntityData.where, fetchEntityData.select, fetchEntityData.searchArray, fetchEntityData.userFilter, fetchEntityData.searchString, fetchEntityData.searchOn, fetchEntityData.dateFilter, fetchEntityData.period, undefined, fetchEntityData.entityIds);
    }
    async validateResourceScope(userId, entity, mode, resourceId) {
        const entityInString = entity.toString().toLowerCase();
        const user = await this.dataSource.getRepository(user_1.User).findOne({
            where: [{ userId: userId }],
            relations: ["userRoles", "userRoles.role"],
        });
        const employeeDetails = await this.dataSource
            .getRepository(employee_entity_1.Employee)
            .findOne({
            where: { userId: userId },
        });
        if (!employeeDetails) {
            return false;
        }
        const roles = (user?.userRoles || [])
            .filter((userRole) => userRole?.role) // Filter out undefined roles
            .map((userRole) => ({
            id: userRole.role.id,
            name: userRole.role.name,
        }));
        for (const role of roles) {
            if (role.name.includes("LeaderShip")) {
                return true;
            }
            let additionalUserIds = [];
            let taggedResourceIds = [];
            if (mode === "view") {
                if (entityInString !== "opportunity") {
                    additionalUserIds = await this.fetchOrgUserIds(employeeDetails.organisationId);
                }
                else {
                    if (["AM", "ISG"].includes(role.name)) {
                        additionalUserIds = await this.fetchBranchUserIds(employeeDetails.branchId);
                    }
                    else {
                        additionalUserIds = await this.fetchReporteeUserIds(userId);
                    }
                    taggedResourceIds = await this.fetchTaggedOprty([
                        ...additionalUserIds,
                        userId,
                    ]);
                }
            }
            else {
                if (entityInString === "opportunity") {
                    additionalUserIds = await this.fetchReporteeUserIds(userId);
                    taggedResourceIds = await this.fetchTaggedOprty([
                        ...additionalUserIds,
                        userId,
                    ]);
                }
                else if (["broker", "insurer", "tpa"].includes(entityInString)) {
                    additionalUserIds = await this.fetchOrgUserIds(employeeDetails.organisationId);
                }
                else {
                    if (["AM", "ISG"].includes(role.name)) {
                        additionalUserIds = await this.fetchBranchUserIds(employeeDetails.branchId);
                    }
                    else {
                        additionalUserIds = await this.fetchReporteeUserIds(userId);
                    }
                }
            }
            if (taggedResourceIds.length > 0 &&
                taggedResourceIds.includes(resourceId)) {
                return true;
            }
            const access = await this.dataSource
                .getRepository(entity)
                .createQueryBuilder("main")
                .where("main.createdBy IN (:...userIds)", {
                userIds: [userId, ...additionalUserIds],
            })
                .andWhere("main.id = :resourceId", { resourceId: resourceId })
                .getCount();
            if (access > 0) {
                return true;
            }
            return false;
        }
    }
    /**
     * Fetches user IDs based on reporting hierarchy.
     * @param userId - The ID of the user whose reportees are to be fetched.
     * @returns An array of user IDs that report to the specified user.
     **/
    async fetchReporteeUserIds(userId) {
        const repository = this.dataSource.getRepository(employee_hierarchy_entity_1.EmployeeHierarchy);
        const userDetails = await repository.find({
            where: { reportingUserId: userId },
            select: ["userId"],
        });
        const userIds = userDetails.map((user) => {
            return user.userId;
        });
        return userIds;
    }
    /**
     * Fetches user IDs based on branch ID.
     * @param branchId - The ID of the branch whose users are to be fetched.
     * @returns An array of user IDs that belong to the specified branch.
     **/
    async fetchBranchUserIds(branchId) {
        const repository = this.dataSource.getRepository(user_1.User);
        const userDetails = await repository.find({
            where: { branchId: branchId },
            select: ["userId"],
        });
        const userIds = userDetails.map((user) => {
            return user.userId;
        });
        return userIds;
    }
    /**
     * Fetches user IDs based on organization ID.
     * @param orgId - The ID of the organization whose users are to be fetched.
     * @returns An array of user IDs that belong to the specified organization.
     **/
    async fetchOrgUserIds(orgId) {
        const lookupRepository = this.dataSource.getRepository(entities_1.LookUp);
        const userStatus = await lookupRepository.findOne({
            where: { lookUpKey: constants_1.EMPLOYEE_STATUS_ACTIVE },
            select: ["id"],
        });
        const repository = this.dataSource.getRepository(employee_entity_1.Employee);
        const userDetails = await repository.find({
            where: { organisationId: orgId, statusLid: userStatus?.id },
            select: ["userId"],
        });
        const userIds = userDetails.map((user) => {
            return user.userId;
        });
        return userIds;
    }
    /**
     * Fetches opportunity IDs based on tagged user IDs.
     * @param userIds - An array of user IDs that are tagged in opportunities.
     * @returns An array of opportunity IDs that the specified users are tagged in.
     **/
    async fetchTaggedOprty(userIds) {
        const repository = this.dataSource.getRepository(entities_1.OpportunityActivityParticipants);
        const userDetails = await repository.find({
            where: { participantId: (0, typeorm_1.In)(userIds) },
            select: ["opportunityId"],
        });
        const opportunityIds = userDetails.map((user) => {
            return user.opportunityId;
        });
        return opportunityIds;
    }
};
exports.ScopeService = ScopeService;
exports.ScopeService = ScopeService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_1.DataSource !== "undefined" && typeorm_1.DataSource) === "function" ? _a : Object, typeof (_b = typeof entity_service_utils_1.EntityService !== "undefined" && entity_service_utils_1.EntityService) === "function" ? _b : Object])
], ScopeService);
